import React, { forwardRef } from 'react';
import { Bar } from 'react-chartjs-2';

const WaterfallChart = forwardRef(({ data, colours = {} }, ref) => {
  if (!data) return <div className="chart-placeholder">No contribution data available</div>;

  const contributors = data.contributors || [];
  const detractors = data.detractors || [];

  const items = [
    ...contributors.map(c => ({ name: c.name || c.asset_class, value: c.contribution })),
    ...detractors.map(d => ({ name: d.name || d.asset_class, value: d.contribution })),
  ].sort((a, b) => b.value - a.value);

  if (items.length === 0) return <div className="chart-placeholder">No contribution data available</div>;

  const labels = items.map(i => i.name);
  const values = items.map(i => i.value);

  const bases = values.map(v => (v >= 0 ? 0 : v));
  const tops = values.map(v => (v >= 0 ? v : 0));

  const chartData = {
    labels,
    datasets: [
      {
        label: 'Contribution',
        data: tops.map((t, i) => [bases[i], t]),
        backgroundColor: values.map(v => (v >= 0 ? (colours.waterfall_positive || '#91CF9B') : (colours.waterfall_negative || '#f0a500'))),
        barPercentage: 0.75,
        categoryPercentage: 0.9,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    layout: { padding: 0 },
    plugins: {
      legend: { display: false },
      tooltip: {
        callbacks: {
          label: (ctx) => {
            const val = values[ctx.dataIndex];
            return `${val >= 0 ? '+' : ''}${val.toFixed(2)}%`;
          },
        },
      },
    },
    scales: {
      x: {
        border: { display: false },
        grid: { display: false },
        ticks: { font: { size: 10 }, maxRotation: 45, minRotation: 0 },
      },
      y: {
        border: { display: false },
        grid: { color: 'rgba(0,0,0,0.1)' },
        ticks: {
          font: { size: 10 },
          callback: (val) => `${val > 0 ? '+' : ''}${val}%`,
        },
      },
    },
  };

  return (
    <div style={{ flex: 1, minHeight: 0, position: 'relative' }}>
      <Bar ref={ref} data={chartData} options={options} />
    </div>
  );
});

WaterfallChart.displayName = 'WaterfallChart';
export default WaterfallChart;
